import styled from 'vue-styled-components';
import { Section, Center, Row, Col } from '@styled/global';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   font-size: 14px;\n   line-height: 18px;\n   list-style: disc;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   list-style-position: outside;\n   margin-left: 0;\n   padding: 20px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #007582;\n   margin-top: 20px;\n   font-size: 14px;\n   line-height: 18px;\n   font-weight: bold;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: column;\n   padding: 0 20px 0 0;\n   width: 100%;\n\n   & a {\n      color: ", ";\n      font-size: 16px;\n      line-height: 20px;\n      font-weight: 400;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var BlockContainer = styled("section", {})(_templateObject(), function (props) {
  return props.theme.secondaryColor;
});
var Title = styled("div", {})(_templateObject2());
var List = styled("ul", {})(_templateObject3());
var ListItem = styled("li", {})(_templateObject4());

// Third party imports
var BulletBlock = {
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    var copy = data.attrs.copy;

    var renderBullets = function renderBullets(bullets) {
      var bulletArray = bullets.map(function (bullet, index) {
        return h(ListItem, {
          "key": index
        }, [bullet]);
      });
      return h(List, [bulletArray]);
    };

    return h(BlockContainer, [h(Title, [copy.title]), renderBullets(copy.bullets), h("RouterLink", {
      "attrs": {
        "to": copy.link.url,
        "id": copy.link.id
      }
    }, [copy.link.label])]);
  }
};

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(Section, [h(Center, [h(Row, [h(Col, {
      "attrs": {
        "width": [12, 12, 12, 6],
        "justifyContent": "flex-start"
      }
    }, [h(BulletBlock, {
      "attrs": {
        "copy": this.copy.bullets[0]
      }
    }), h(BulletBlock, {
      "attrs": {
        "copy": this.copy.bullets[1]
      }
    }), h(BulletBlock, {
      "attrs": {
        "copy": this.copy.bullets[2]
      }
    })]), h(Col, {
      "attrs": {
        "width": [12, 12, 12, 6],
        "justifyContent": "flex-start"
      }
    }, [h(BulletBlock, {
      "attrs": {
        "copy": this.copy.bullets[3]
      }
    }), h(BulletBlock, {
      "attrs": {
        "copy": this.copy.bullets[4]
      }
    })])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
